import { observable, action } from 'mobx';
import Api from 'api/api';

class Auth {
    @observable token;

    constructor(rootStore) {
        this.rootStore = rootStore;

        // TODO: Make this more secure, because this can be injected easily
        const token = localStorage.getItem('token');

        try {
            this.token = token ? JSON.parse(token) : null;
        } catch (e) {
            console.error('Saved token cannot be parsed, removing');
            localStorage.removeItem('token');
            this.token = null;
        }
    }

    @action
    doLogin(username, password) {
        const q = Api.OAuth.token(username, password);

        q.then(response => {
                // Store token in the store
                this.loginSuccess(response.data);
            })
            .catch(err => {
                // TODO: Show nice error
                console.log(err);
            });

        return q;
    }

    @action
    loginSuccess(token) {
        // Set and store the tokens
        this.token = token;
        localStorage.setItem('token', JSON.stringify(token));
    }

    @action
    invalidGrant(err) {
        // For now just log out
        this.token = null;
        localStorage.removeItem('token');

        // TODO: Show message that session has expired
    }

    @action
    logout() {
        this.token = null;

        localStorage.removeItem('token');
    }
}

export default Auth;


// WEBPACK FOOTER //
// ./src/store/auth.js